import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

const loadingMessages = [
  "We are Spiking. Please wait.",
  "Spiking real-time Wall Street signals...",
  "SpikingAI® calibrating market intelligence...",
  "Your Spiking edge is loading...",
];

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
  },
  spinnerWrapper: {
    position: "relative",
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    borderRadius: "50%",
    width: 48,
    height: 48,
    position: "absolute",
    borderTop: "3px solid rgba(72,119,229, 0.2)",
    borderRight: "3px solid rgba(72,119,229, 0.2)",
    borderBottom: "3px solid rgba(72,119,229, 0.2)",
    borderLeft: "3px solid #4877e5",
    transform: "translateZ(0)",
    animation: "$spin 0.8s infinite linear",
  },
  counter: {
    position: "absolute",
    color: "#4877e5",
    fontSize: 12,
    fontWeight: 600,
  },
  message: {
    color: "#6b7280",
    fontSize: 14,
    fontWeight: 600,
    marginTop: 16,
    textAlign: "center",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));

const InlineLoader = ({ minHeight }) => {
  const classes = useStyles();
  const [seconds, setSeconds] = useState(0);
  const [message] = useState(
    () => loadingMessages[Math.floor(Math.random() * loadingMessages.length)]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={classes.wrapper}
      style={minHeight != null ? { minHeight } : undefined}
    >
      <div className={classes.spinnerWrapper}>
        <div className={classes.spinner} />
        <div className={classes.counter}>{seconds}s</div>
      </div>
      <div className={classes.message}>{message}</div>
    </div>
  );
};

export default InlineLoader;
